<template>
    <div class="contact" :class="stepActive == 1 ? 'bg-gray' : ''">
        <div class="top">
            <div class="title">Online Assessment</div>
        </div>
        <div class="con">
            <div class="title">
                Employee Guarantee Assessment Form
                <br>
                （SID/482、186、494）
            </div>
        </div>
        <div class="step">
            <el-steps :active="stepActive" align-center finish-status="success">
                <el-step title="Evaluation Questions"></el-step>
                <el-step title="Personal Information"></el-step>
                <el-step title="Submission Successful"></el-step>
            </el-steps>
        </div>
        <div v-if="stepActive == 0">
            <div class="form">
                <div class="form-list" v-for="item in questionList">
                    <div class="form-title">{{ item.title }}:</div>
                    <div class="question-lists">
                        <div class="question-list" v-for="question in item.children">
                            <div class="question-title">{{ question.name }}:</div>
                            <el-radio-group v-if="question.type == 'radio'" v-model="question.active">
                                <el-radio v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-if="question.type == 'checkbox'" v-model="question.active">
                                <el-checkbox v-for="option in question.option" :key="option.name" :label="option.name">
                                    {{ option.name }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <template v-if="question.type == 'input'">
                                <el-input style="width: 400px;" v-model="question.active" placeholder="请填写" />
                            </template>
                            <div class="tip" v-if="question.tip">{{ question.tip }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="submitForm">Submit</el-button>
            </div>

        </div>
        <div v-if="stepActive == 1">
            <div class="step1">
                <!-- <p class="score">您的评分：<span>{{ totalScore }}</span>分</p> -->
                <div class="step-1">
                    <div class="input-title"><span>*</span>Name</div>
                    <el-input placeholder="please enter your name" v-model="form.name"></el-input>
                    <div class="input-title"><span>*</span>Email</div>
                    <el-input placeholder="please enter your email" v-model="form.email"></el-input>
                    <div class="input-title">Mobile Number</div>
                    <el-input placeholder="please enter your mobile number" v-model="form.mobile"></el-input>
                    <div class="input-title">Source</div>
                    <el-input placeholder="please enter your source" v-model="form.source"></el-input>
                    <div class="input-title">Employer</div>
                    <el-select placeholder="please select your employer" v-model="form.employer">
                        <el-option label="Yes" value="Yes"></el-option>
                        <el-option label="Interview" value="Interview"></el-option>
                        <el-option label="No" value="No"></el-option>
                    </el-select>
                    <div class="input-title"><span>*</span>WeChat Account</div>
                    <el-input placeholder="please enter your wechat account" v-model="form.wx_code"></el-input>
                    <div class="input-title">Message</div>
                    <el-input placeholder="please enter your message" v-model="form.about"></el-input>
                    <div class="input-title">Attachment</div>
                    <el-radio v-model="form.reportType" label="1">Upload Image</el-radio>
                    <el-radio v-model="form.reportType" label="2">Upload File</el-radio>
                    <el-upload ref="child1" class="upload-demo"
                        :action="form.reportType == 1 ? host + '/VisApi/uploadImg' : host + '/VisApi/uploadfile'"
                        :on-success="successReport1" :before-remove="removeReport1" :file-list="fileList"
                        :accept="form.reportType == 1 ? '.png, .jpg' : '.rar, .zip, .xls, .xlsx, .doc, .docx'"
                        :before-upload="beforeAvatarUpload1" :on-exceed="onExceedFn1" :limit="1">
                        <el-button type="primary">Click to Upload</el-button>
                        <template #tip>
                            <div class="el-upload__tip">
                                Please upload {{ form.reportType == 1 ? 'png, jpg' : "rar, zip, xls, xlsx, doc, docx" }}
                                files
                            </div>
                        </template>
                    </el-upload>
                </div>
            </div>
            <div class="btn-con">
                <el-button type="primary" class="btn" @click="backFn(0)">Back to Evaluation Questions</el-button>
                <el-button type="primary" class="btn" @click="subFn">Submit</el-button>
            </div>
        </div>
        <div v-if="stepActive == 2">
            <p class="step2">
                Thank you for your trust! Your information has been successfully submitted! <br>
                We have received your evaluation information. We will contact you as soon as possible to provide
                preliminary
                conclusions and suggestions. <br>
                If urgent processing is required, please indicate "urgent" in the message and specify the reason. The
                New Legend
                Visa Service Team is happy to assist you. <br>
                Our team comprises officially certified registered migration agents from Australia and New Zealand, who
                have
                been in the industry for 10 years and have achieved positive results for over 30,000 clients. <br>
                We are in Sydney, and our working hours are from 9:00 am to 5:30 pm Sydney time. You are also welcome to
                add our
                customer service WeChat for timely communication.
                <img class="sandywx" src="../../assets/imgs/sandywx.png" alt="">
                <el-button type="primary" class="btn" @click="stepActive = 0">Restart Test</el-button>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            totalScore: 0,
            stepActive: 2,
            questionList: [
                {
                   
                    "title": "Applicant and Occupation",
                    "children": [
                        {
                            "name": "Proposed category",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "SID/482（Core Skills）" },
                                { "name": "186（TRT）" },
                                { "name": "186（DE）" },
                                { "name": "494 Remote Area Employer Sponsorship" },
                                { "name": "I don't know which category I should apply for" }
                            ]
                        },
                        {
                            "name": "Nomination Occupation (ANZSCO)",
                            "type": "input",
                            "tip": "If unsure, you can fill in the name of your current job position.",
                            "active": [],
                            "option": []
                        },
                        {
                            "name": "Occupational assessment (if applicable)",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Passed" },
                                { "name": "In process" },
                                { "name": "Not started" },
                                { "name": "This occupation usually does not require (needs assessment)" }
                            ]
                        },
                        {
                            "name": "Relevant work experience (full-time with social insurance, tax payment, and labor contract)",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Less than 1 year" },
                                { "name": "1-2 years" },
                                { "name": "3-5 years" },
                                { "name": "5-8 years" },
                                { "name": "Over 8 years" }
                            ]
                        },
                        {
                            "name": "English proficiency (IELTS, PTE, etc. are all acceptable)",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "No score" },
                                { "name": "IELTS 4x5" },
                                { "name": "IELTS 4x6" },
                                { "name": "IELTS 4.0 with 7 or above in each band" },
                                { "name": "Other equivalent achievements (required to be filled in)" }
                            ]
                        },
                        {
                            "name": "Whether a license/registration is required",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Not required" },
                                { "name": "Required and already available" },
                                { "name": "Required but not yet available/to be evaluated" }
                            ]
                        },
                        {
                            "name": "Is the applicant currently in Australia or abroad?",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Domestic" },
                                { "name": "Overseas" }
                            ]
                        },
                        {
                            "name": "The current status of the Australian visa held by the applicant",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "485 Graduate Work Visa" },
                                { "name": "500 Study Permit" },
                                { "name": "485 Sub-application" },
                                { "name": "407 Training Visa" },
                                { "name": "417/462 Working Holiday Visa" },
                                { "name": "600 Tourist Visa" },
                                { "name": "482 Visa" },
                                { "name": "Bridge Pass" },
                                { "name": "Please specify for other types of visas" }
                            ]
                        },
                        {
                            "name": "Applicant's nationality",
                            "type": "input",
                            "tip": "",
                            "active": [],
                            "option": []
                        }
                    ]
                },
                {
                    "title": "Risk investigation",
                    "children": [
                        {
                            "name": "Whether there is a history of visa rejection/cancellation in Australia",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "None" },
                                { "name": "Yes (to be disclosed and evaluated)" }
                            ]
                        },
                        {
                            "name": "Whether to plan to bring family members",
                            "type": "radio",
                            "tip": "",
                            "active": [],
                            "option": [
                                { "name": "Not carrying" },
                                { "name": "Spouse" },
                                { "name": "Children" },
                                { "name": "Spouse + Children" }
                            ]
                        }
                    ]
                }
            ],
            host: "/api",
            form: {
                name: '',
                email: '',
                mobile: '',
                reviewFileUrl: '',
                about: '',
                type_id: 4,
                reportType: '2',
                wx_code: '',
                employer: ''
            },
            file_url: [],
            fileList: [],
            loading: false,
        };
    },
    mounted() {
        this.stepActive = 0
    },
    methods: {
        backFn(index) {
            this.stepActive = index;
            window.scrollTo(0, 0);
        },
        onExceedFn1() {
            this.$message.error("Only one file is allowed");
        },
        successReport1(a, b) {
            console.log(a, '-----1--21-1-1aaa');
            this.file_url = a.data;
            this.fileList.push(a.data);
            this.$message.success("Upload successful");
            this.loading = false;
        },
        removeReport1() {
            this.file_url = [];
            this.fileList = [];
        },
        handleRemove1() {
            this.file_url = [];
            this.fileList = [];
        },
        beforeAvatarUpload1(rawFile) { },
        subFn() {
            if (!this.form.name) {
                this.$message.error('Please enter your name')
                return
            }
            if (!this.form.email) {
                this.$message.error('Please enter your email')
                return
            }
            if (!this.form.wx_code) {
                this.$message.error('Please enter your WeChat account')
                return
            }

            this.$http.review_add4({
                name: this.form.name,
                email: this.form.email,
                mobile: this.form.mobile,
                about: this.form.about,
                type_id: this.form.type_id,
                wx_code: this.form.wx_code,
                employer: this.form.employer,
                reviewtext: JSON.stringify(this.questionList),
                reviewNum: this.score,
                reviewFileUrl: this.file_url
            }).then(res => {
                console.log(res, '------')
                this.$message.success('Submission successful')
                this.stepActive = 2;
            })
        },
        submitForm() {
            // 计算总分
            // let totalScore = 0;
            // this.questionList.forEach(questionItem => {
            //     if (!Array.isArray(questionItem.children)) return;
            //     questionItem.children.forEach(child => {
            //         const optionScoreMap = child.option.reduce((map, option) => {
            //             const validScore = Number(option.score) || 0;
            //             map[option.name] = validScore;
            //             return map;
            //         }, {});
            //         switch (child.type) {
            //             case 'radio':
            //                 totalScore += optionScoreMap[child.active] || 0;
            //                 break;
            //             case 'checkbox':
            //                 child.active.forEach(activeName => {
            //                     totalScore += optionScoreMap[activeName] || 0;
            //                 });
            //                 break;
            //             default:
            //                 console.warn(`未处理的题型：${child.type}`, child);
            //                 break;
            //         }
            //     });
            // });
            this.stepActive = 1;
            window.scrollTo(0, 0);
            // this.totalScore = totalScore;
        },
    }
}
</script>

<style lang="less" scoped>
.bg-gray {
    background-color: #f1f1f1;
    padding-bottom: 10px;
}

.upload-demo {
    margin-top: 20px;
    margin-bottom: 40px;
}

.btn-con {
    margin: 0 auto 150px;
    display: flex;
    justify-content: center;
}

.contact {
    .step2 {
        margin: 50px auto 100px;
        font-size: 18px;
        text-align: center;

        .sandywx {
            width: 200px;
            height: 200px;
            display: block;
            margin: 10px auto 0;
        }

        .btn {
            margin: 20px auto 0;
        }
    }

    .step {
        max-width: 700px;
        margin: 30px auto;
    }

    .step1 {
        margin: 0 auto 70px;
        max-width: 600px;
        background-color: #fff;
        padding: 20px 40px;
        border-radius: 10px;

        .score {
            font-size: 20px;

            span {
                margin-right: 6px;
                color: #222222;
                font-size: 30px;
                font-weight: 500;
            }
        }

        .input-title {
            margin-top: 40px;
            color: #333;

            span {
                color: red;
                margin-right: 4px;
            }
        }
    }

    .btn {
        display: block;
    }

    .form {
        max-width: 900px;
        margin: 0 auto;
        margin-bottom: 50px;
        border: 1px solid #ccc;
        background-color: #fff;

        .form-title {
            font-size: 26px;
            font-weight: 500;
            margin: 20px 0;
            text-indent: 20px;
            color: #333;
        }

        .question-lists {
            display: flex;
            flex-wrap: wrap;
        }

        .question-list {
            width: 100%;
            display: inline-block;
            box-sizing: border-box;
            padding: 20px;
            line-height: 30px;
            border-bottom: 1px solid #ccc;
            background-color: #f1f1f1;
        }


        .tip {
            font-size: 14px;
            line-height: 20px;
            color: #222222;
            margin-top: 5px;
        }

        .question-title {
            font-size: 20px;
            margin-bottom: 10px;
        }
    }

    .con {
        max-width: 1200px;
        margin: 50px auto;
        box-sizing: border-box;
    }

    .title {
        font-size: 30px;
        font-weight: 600;
        text-align: center;
        margin: 20px 0;
    }

    .text {
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;

        p {
            font-size: 16px;
            line-height: 30px;
            margin: 10px 0;
        }

        .border {
            border: 1px solid #ccc;
            padding: 10px;
            margin: 10px 0;
            border-radius: 10px;

            p {
                font-size: 14px;
                line-height: 20px;
                margin: 10px 0;
            }
        }
    }

    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/concat_us.png');
        background-size: cover;
        transition: .3s all;
        background-position: center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #222222;
            text-shadow: 3px 3px 5px #fff;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: cover;

            img {
                transform: scale(1.1);
            }
        }
    }

}


@media (max-width: 600px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
            }
        }

        .con {
            padding: 0 20px;
        }

        .title {
            font-size: 20px;
        }

        .step {
            zoom: 0.7;
        }

        .step1 {
            padding: 10px 20px;
        }

        .step2 {
            font-size: 18px;
            margin: 100px auto 150px;
        }

        .step2+.btn {
            margin: 0 auto 30px;
        }

        .form {
            padding: 0 15px;
            box-sizing: border-box;

            .question-list {
                padding: 10px;
            }

            .form-title {
                font-size: 20px;
            }

            .question-title {
                font-size: 16px;
            }

            .question-list:nth-child(2n) {
                border-left: none;
            }

            .question-list {}
        }

        .text p {
            font-size: 14px;
        }

        .text {
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/en/evaluateMaster.vue